/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react/jsx-no-undef */

import React, { useEffect, useState } from "react";
import Table from "../../../Components/ExtraComponents/Tables/FullDataTable";
import Content from "../../../Components/Dashboard/Content/Content";
import { getAllBrokerTrades, renewTrade } from "../../../Service/admin.service";
import Modal from "../../../Components/ExtraComponents/Modal";
import { fDateTimeSuffix } from "../../../Utils/Date_formet";
import Swal from "sweetalert2";
import { tr } from "date-fns/locale";

function Broker_Trade_Monitoring() {
    const token = localStorage.getItem("token");

    const [tradeList, setTradeList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [loading, setLoading] = useState(false);

    const [search, setSearch] = useState("");
    const [selectedUser, setSelectedUser] = useState("ALL");
    const [selectedStatus, setSelectedStatus] = useState("REJECTED");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    const [userOptions, setUserOptions] = useState([]);

    // MODAL STATES FIXED
    const [showModal, setShowModal] = useState(false);
    const [selectedTrade, setSelectedTrade] = useState(null);

    const openModal = (row) => {
        setSelectedTrade(row);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    // SAFE JSON PARSER
    const safeJSONParse = (str) => {
        if (!str) return "-";
        try {
            return JSON.stringify(JSON.parse(str), null, 2);
        } catch {
            return str;
        }
    };

    const fetchData = async () => {
        setLoading(true);

        const body = {
            search,
            userName: selectedUser,
            status: selectedStatus,
            fromDate: fromDate || null,
            toDate: toDate || null,
            
        };

        const res = await getAllBrokerTrades(body, token);

        if (res?.status) {
            setUserOptions(res.users);
            setTradeList(res.data);
            setFilteredList(res.data);
        }

        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        fetchData();
    }, [search, selectedUser, selectedStatus, fromDate, toDate]);

    const handleRenew = async (row) => {
        const confirm = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to renew this failed trade?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Renew it!"
        });

        if (confirm.isConfirmed) {
            setLoading(true);
            const res = await renewTrade({ id: row._id }, token);
            if (res?.status) {
                Swal.fire("Success", res.message, "success");
                fetchData();
            } else {
                Swal.fire("Error", res?.message || "Failed to renew trade", "error");
            }
            setLoading(false);
        }
    };

    const columns = [
        { name: "User Name", selector: (row) => row.UserName, sortable: true, "width": "150px" },
        { name: "Symbol", selector: (row) => row.symbol },
        { name: "Type", selector: (row) => row.type },
        { name: "Strategy", selector: (row) => row.strategy },
        { name: "Order Status", selector: (row) => row.order_status, "width": "180px" },
        { name: "Signal", selector: (row) => row.signal },
        {
            name: "Created At",
            selector: (row) => new Date(row.createdAt).toLocaleString(),
            "width": "180px"
        },
        {
            name: "View",
            cell: (row) => (
                <button className="btn btn-primary btn-sm" onClick={() => openModal(row)}>
                    View
                </button>
            ),
            ignoreRowClick: true,
        },
        {
            name: "Action",
            cell: (row) => (
                row.signal === "REJECTED" ? (
                    <button
                        className={`btn btn-sm ${row.is_renew ? 'btn-success' : 'btn-warning'}`}
                        onClick={() => !row.is_renew && handleRenew(row)}



                        disabled={row.is_renew}
                    >
                        {row.is_renew ? "Renewed" : "Renew"}
                    </button>
                ) : "-"
            ),
            ignoreRowClick: true,
            "width": "120px"
        },
    ];

    return (
        <Content Page_title="Broker Trade Monitoring" button_status={false}>

            {/* Filters */}
            <div className="container mt-4 mb-4">

                <div className="row g-3">

                    {/* From Date */}
                    <div className="col-md-3 col-sm-6">
                        <label className="fw-semibold mb-1">From Date</label>
                        <input
                            type="date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                            className="form-control shadow-sm"
                        />
                    </div>

                    {/* To Date */}
                    <div className="col-md-3 col-sm-6">
                        <label className="fw-semibold mb-1">To Date</label>
                        <input
                            type="date"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                            className="form-control shadow-sm"
                        />
                    </div>

                    {/* Search Symbol */}
                    {/* <div className="col-md-3 col-sm-6">
                        <label className="fw-semibold mb-1">Search Symbol</label>
                        <input
                            className="form-control shadow-sm"
                            placeholder="Search Symbol"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div> */}

                    {/* User Dropdown */}
                    <div className="col-md-3 col-sm-6">
                        <label className="fw-semibold mb-1">User</label>
                        <select
                            className="form-control shadow-sm"
                            value={selectedUser}
                            onChange={(e) => setSelectedUser(e.target.value)}
                        >
                            <option value="ALL">All Users</option>
                            {userOptions.map((u) => (
                                <option key={u} value={u}>{u}</option>
                            ))}
                        </select>
                    </div>

                    {/* Status Dropdown */}
                    <div className="col-md-3 col-sm-6">
                        <label className="fw-semibold mb-1">Status</label>
                        <select
                            className="form-control shadow-sm"
                            value={selectedStatus}
                            onChange={(e) => setSelectedStatus(e.target.value)}
                        >
                            <option value="ALL">All Status</option>
                            <option value="REJECTED">Rejected</option>
                            <option value="ACCEPTED">Accepted</option>
                        </select>
                    </div>

                </div>

            </div>


            {/* TABLE */}
            <div className="container">
                {loading ? <p>Loading...</p> : <Table columns={columns} data={filteredList} />}
            </div>

            {/* MODAL FIXED */}
            {showModal && selectedTrade && (
                <Modal
                    isOpen={showModal}
                    size="xl"
                    title="Broker Response Details"
                    hideBtn={true}
                    handleClose={closeModal}
                >
                    <div className="table-responsive p-2">

                        <table className="table table-bordered">
                            <tbody>
                                <tr>
                                    <th>User Name</th>
                                    <td>{selectedTrade.UserName}</td>

                                    <th>Broker Name</th>
                                    <td>{selectedTrade.broker_name}</td>
                                </tr>

                                <tr>
                                    <th>Symbol</th>
                                    <td>{selectedTrade.symbol}</td>

                                    <th>Created At</th>
                                    <td>{fDateTimeSuffix(selectedTrade.createdAt)}</td>
                                </tr>

                                <tr>
                                    <th>Order Status</th>
                                    <td colSpan={3}>
                                        <span
                                            className={`badge p-2 ${selectedTrade.order_status === "ACCEPTED"
                                                ? "bg-success"
                                                : "bg-danger"
                                                }`}
                                        >
                                            {selectedTrade.order_status}
                                        </span>
                                    </td>
                                </tr>

                                <tr>
                                    <th>Reject Reason</th>
                                    <td colSpan={3} className="text-danger">
                                        {selectedTrade.reject_reason || "-"}
                                    </td>
                                </tr>

                                <tr>
                                    <th>Order ID</th>
                                    <td colSpan={3}>{selectedTrade.order_id || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Signal</th>
                                    <td colSpan={3}>
                                        <pre className="bg-light p-2 rounded border">
                                            {safeJSONParse(selectedTrade.send_request)}
                                        </pre>
                                    </td>
                                </tr>

                                <tr>
                                    <th>Order Data</th>
                                    <td colSpan={3}>
                                        <pre className="bg-light p-2 rounded border">
                                            {safeJSONParse(selectedTrade.full_response)}
                                        </pre>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </Modal>
            )}

        </Content>
    );
}

export default Broker_Trade_Monitoring;
